import { SocketTopics } from "@shared/types";
import {
  GetTopicDataFunc,
  SocketPnlArgs,
  SocketResult,
  TopicReducerHandler,
  TradeIdsMapping,
  TradeIdsState,
} from "@shared/services/socket/types";
import { pick } from "lodash";
import { isSymbol } from "@shared/types/utils";

export class TradeIdsHandler<Topic extends SocketTopics.PNL>
  implements TopicReducerHandler<Topic>
{
  private state: TradeIdsMapping = {
    trade_ids: {},
  };

  add({ tradeIds }: SocketPnlArgs) {
    let shouldUpdate = false;
    tradeIds.map((tradeId) => {
      const isExist = tradeId in this.state.trade_ids;

      if (isExist) {
        ++this.state.trade_ids[tradeId];
      } else {
        this.state.trade_ids = { ...this.state.trade_ids, [tradeId]: 1 };
        shouldUpdate = true;
      }
    });

    return shouldUpdate;
  }

  remove(args: SocketPnlArgs): [boolean, boolean] {
    let resubscribe = false;
    args?.tradeIds?.map((tradeId) => {
      --this.state.trade_ids[tradeId];
      if (this.state.trade_ids[tradeId] <= 0) {
        resubscribe = true;
        delete this.state.trade_ids[tradeId];
      }
    });

    const unsubscribe = !Object.keys(this.state.trade_ids).length;

    return [!unsubscribe && resubscribe, unsubscribe];
  }

  getState = (): TradeIdsState => {
    const trade_ids = Object.keys(this.state.trade_ids).map((tradeId) =>
      Number(tradeId)
    );

    return { trade_ids };
  };

  getData: GetTopicDataFunc<Topic> = (args, data) => {
    if (isSymbol(args) || !data) return;
    const { tradeIds } = args;
    return pick(data, tradeIds) as SocketResult<Topic>;
  };
}
